<div [class]="customClasses().formGroup">
  <label [class]="customClasses().label" [class.disabled]="ngControl.disabled">
    {{ label() }}
    @if (inputRequiredIndicatorEnabled()) {
      <span class="text-danger"> *</span>
    }
  </label>

  <ng-select
    [items]="list()"
    [bindValue]="bindField()"
    [bindLabel]="labelField()"
    [placeholder]="placeholder()"
    [formControl]="ngControl.control | formControl"
    [multiple]="multiple()"
    [clearable]="clearable()"
    [searchable]="true"
    [addTag]="addTagCallback ? addTagFn : false"
    [appendTo]="appendTo() ?? ''"
    [class.is-invalid]="ngControl.touched && ngControl.invalid"
  >
    @if (addTagCallback) {
      <ng-template ng-tag-tmp let-search="searchTerm">
        <span class="th-add-tag">
          <span class="mdi mdi-plus-circle-outline"></span>
          Create "{{ search }}"
        </span>
      </ng-template>
    }
  </ng-select>

  <div class="field-error-slot">
    @if (ngControl.touched && ngControl.control?.errors?.['required']) {
      <div class="invalid-feedback d-block">Please select a {{ label() | lowercase }}</div>
    }
  </div>
</div>
